import React from 'react';
import '../Profile.css';

const user = {
  pseudo: 'Sarah',
  avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
  bio: "Passionnée de musique pop et électro. J'adore découvrir de nouveaux artistes et partager mes coups de cœur !",
  stats: [
    { label: 'Contributions', value: 152 },
    { label: 'Playlists', value: 7 },
    { label: 'Commentaires', value: 34 },
  ],
};

export default function Profile() {
  return (
    <div className="profile-root">
      <div className="profile-header">
        <img className="profile-avatar" src={user.avatar} alt={user.pseudo} />
        <div className="profile-pseudo">{user.pseudo}</div>
      </div>
      <div className="profile-bio">{user.bio}</div>
      <div className="profile-stats">
        {user.stats.map((s, i) => (
          <div className="profile-stat" key={i}>
            <strong>{s.value}</strong>
            <span>{s.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
} 